import { Component } from 'react';
import classNames from 'classnames';

class DragAndDrop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drag: false
    };
    this.dragCounter = 0;
  }

  handleDrag() {
    return e => {
      e.preventDefault();
      e.stopPropagation();
    };
  }

  handleDragIn() {
    const context = this;
    return e => {
      e.preventDefault();
      e.stopPropagation();
      context.dragCounter++;
      if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
        context.setState({ drag: true });
      }
    };
  }

  handleDragOut() {
    const context = this;
    return e => {
      e.preventDefault();
      e.stopPropagation();
      context.dragCounter--;
      if (context.dragCounter === 0) {
        context.setState({ drag: false });
      }
    };
  }

  handleDrop() {
    return e => {
      e.preventDefault();
      e.stopPropagation();
      if (this.props.disabled) {
        return;
      }
      this.setState({ drag: false });
      if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
        this.props.handleDrop(e.dataTransfer.files);
        e.dataTransfer.clearData();
        this.dragCounter = 0;
      }
    };
  }

  componentDidMount() {
    const div = this.refs.dropRef;
    div.addEventListener('dragenter', this.handleDragIn());
    div.addEventListener('dragleave', this.handleDragOut());
    div.addEventListener('dragover', this.handleDrag());
    div.addEventListener('drop', this.handleDrop());
  }

  componentWillUnmount() {
    const div = this.refs.dropRef;
    div.removeEventListener('dragenter', this.handleDragIn());
    div.removeEventListener('dragleave', this.handleDragOut());
    div.removeEventListener('dragover', this.handleDrag());
    div.removeEventListener('drop', this.handleDrop());
  }

  render() {
    return (
      <div className={classNames('drag-drop', { disabled: this.props.disabled, hovering: this.state.drag })} ref="dropRef">
        {this.props.children}
      </div>
    );
  }
}

export { DragAndDrop };
